const Item = ({guid, title, locationGuid, mutate}: ISubProductItemProps) => {
  return (
    <>
      <p
        className=" my-6"
        onClick={() =>
          mutate({
            cultivation_guid: locationGuid,
            subproduct_guid: guid,
          })
        }
      >
        {title}
      </p>
    </>
  );
};

export default Item;
